
export const isEdge = document.documentMode || /Edge/.test(navigator.userAgent);